"use client";

import type { ReactNode } from "react";
import styles from "./flipCard.module.scss";
import { MessageIcon, RefreshIcon } from "../../../assets/icons";

interface FlipCardProps {
	// Front side props
	frontImage?: string;
	frontIcon?: ReactNode;
	frontTitle?: string;
	frontText?: string;
	frontBackground?: string;

	// Back side props
	backText?: string;
	backBackground?: string;
	backTextAuthor?: string;

	// Card dimensions
	width?: string;
	height?: string;
	className?: string;
}

export default function FlipCard({
	frontImage,
	frontIcon,
	frontTitle,
	frontText,
	frontBackground = "#ffffff",
	backText,
	backBackground = "#f5f5f5",
	width = "350px",
	height = "400px",
	className = "",
	backTextAuthor,
}: Readonly<FlipCardProps>) {
	return (
		<div className={`${styles.flipCard} ${className}`}>
			<div className={styles.flipCardInner}>
				{/* Front Side */}
				<div className={styles.flipCardFront} style={{ backgroundColor: frontBackground }}>
					{frontImage && (
						<div className={styles.imageContainer}>
							<img src={frontImage || "/placeholder.svg"} alt={frontTitle ?? "Card image"} />
						</div>
					)}

					<div className={styles.content}>
						<div className={styles.titlebar}>
							<div className={styles.titleIconbar}>
								{frontIcon && <div className={styles.iconContainer}>{frontIcon}</div>}
								{frontTitle && <h3 className={styles.title}>{frontTitle}</h3>}
							</div>
							<MessageIcon />
						</div>

						{frontText && <p className={styles.text}>{frontText}</p>}
					</div>
				</div>

				{/* Back Side */}
				<div className={styles.flipCardBack} style={{ backgroundColor: backBackground }}>
					<div className={styles.backContent}>
						<div>
							{backText && <p className={styles.backText}>{backText}</p>}
							{backTextAuthor && <p className={styles.backTextAuthor}>{backTextAuthor}</p>}
						</div>
						<div style={{ textAlign: "right"}}>
							<RefreshIcon style={{ height: 18, width: 18 }} color="#F9A01B" />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
